import { tmrOperationController } from 'tmr/controllers/operation/operation'
import './phaseToPhase.scss'
import templateUrl from './phaseToPhase.html'
import icon from './phaseToPhase.svg'
import _ from 'lodash'

/**
 * phaseToPhase Operation route.
 *
 * @namespace routes.OperationPhaseToPhase
 * @type {TmrRoute}
 */
export const route = {
  name: 'operations.phaseToPhase',
  label: 'OPERATIONS.PHASETOPHASE.TITLE',
  url: '/phaseToPhase',
  resolve: {
    antenna: /*@ngInject*/ ActiveWorkstation => ActiveWorkstation.getAntennas(),
  },
  component: 'tmrOperationPhaseToPhase',
  accessControl: ['Operation.perform', 'Operation.PhaseToPhase.perform'],
  weight: 7,
  icon,
}

/**
 * PhaseToPhase Operation component
 *
 * @type {ngComponent}
 * @todo document
 */
export const tmrOperationPhaseToPhase = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrOperationPhaseToPhaseController',
  bindings: {
    antenna: '<',
    loggedUser: '<',
  },
}

/**
 * Controller of component {@link tmrOperationPhaseToPhase}.
 *
 * @type {ngController}
 */
export class tmrOperationPhaseToPhaseController extends tmrOperationController {
  constructor(
    $mdDialog,
    TmrToast,
    TmrOperationHelper,
    debounce,
    ProductionLot
  ) {
    'ngInject'
    super($mdDialog, TmrToast, TmrOperationHelper)
    Object.assign(this, { debounce, ProductionLot })
  }

  initVars() {
    super.initVars()
    this.getProductionLot = this.debounce(200, () => this.updateLotsList())
    this.lotsRead = []
    this.epcsRead = []
    this.workflows = []
    this.unknownCounter = 0
    this.isWarningShowed = false
  }

  /**
   * OnClear action
   */
  onClear() {
    super.onClear()
    this.lotsRead = []
    this.epcsRead = []
    this.workflows = []
    this.unknownCounter = 0
    this.isWarningShowed = false
  }

  /**
   * onEpcRead event from antenna
   */
  onEpcRead() {
    this.getProductionLot()
  }

  /**
   * Update list of lots read
   */
  updateLotsList() {
    if (
      this.antenna.$epcs &&
      this.antenna.$epcs.length !== this.epcsRead.length
    ) {
      // get new epcs read from antenna
      const newEpcs = _.difference(this.antenna.$epcs, this.epcsRead)
      // add new epcs to epcsRead array
      const newArray = _.union(this.epcsRead, newEpcs)
      this.epcsRead = newArray

      let placeError = false
      // Get lots info
      this.ProductionLot.query({
        epc: newEpcs,
        'place.id': this.loggedUser.place.id,
      }).$promise.then(res => {
        res.forEach(lot => {
          this.lotsRead.push(lot)

          // check if current phase match with lot phase
          if (!this.isWarningShowed) {
            this.CheckLotsCurrentPhase()
          }

          // check workflow
          if (!_.includes(this.workflows, lot.workflow.id)) {
            this.workflows.push(lot.workflow.id)
          }
          // check workflow.worker match with loggedUser.place
          if (lot.workflow.worker.id !== this.loggedUser.place.id) {
            placeError = true
          }
        })
        this.unknownCounter = this.epcsRead.length - this.lotsRead.length

        // check if read epcs with different workflows - Blocking Error
        if (this.workflows.length > 1) {
          this.TmrToast.error('OPERATIONS.PHASETOPHASE.WORKFLOWERROR')
          this.antenna.$stop()
        } else if (placeError) {
          this.TmrToast.error('OPERATIONS.PHASETOPHASE.PLACEERROR')
          this.antenna.$stop()
        }
      })
    }
  }

  // check if this.lots are in the same status phase
  CheckLotsCurrentPhase() {
    let currentPhase = null

    // check if are all in the same phase
    for (let i = 0; i < this.lotsRead.length; i++) {
      // set first value for currentPhase
      if (!currentPhase) currentPhase = this.lotsRead[i].currentPhase || 'INIT'

      if (this.lotsRead[i].currentPhase) {
        // check if this.lotsRead[i] currentPhase is the same of others this.lotsRead[i] currentPhase
        // and are in the same operation phase
        if (
          currentPhase === 'INIT' ||
          currentPhase.phase.id !== this.lotsRead[i].currentPhase.phase.id ||
          this.getOperationPhase(currentPhase) !==
            this.getOperationPhase(this.lotsRead[i].currentPhase)
        ) {
          currentPhase = 'MIXED'
          break
        }
      } else {
        // check if tag read hasn't currentPhase, but already exists currentPhase for old tags read
        if (currentPhase && currentPhase !== 'INIT') {
          currentPhase = 'MIXED'
          break
        }
      }
    }

    // Check if currentPhase is null -> set to initial phase
    if (!currentPhase) currentPhase = 'INIT'

    // Show warning if mixed
    if (currentPhase === 'MIXED') {
      this.TmrToast.error('OPERATIONS.PHASETOPHASE.MULTIPLEPHASES')
      this.isWarningShowed = true
    }
  }

  /** from phase get it's operation status */
  getOperationPhase(phase) {
    if (!phase || (!phase.startDate && !phase.completionDate)) return null
    if (phase.startDate && !phase.completionDate) return 'IN_PROGRESS'
    if (phase.startDate && phase.completionDate) return 'COMPLETED'
    return null
  }

  // check if disable 'change phase' btn
  isSubmitDisabled() {
    return !this.lotsRead || this.workflows.length !== 1
  }

  onConfirm(targetEvent) {
    super.onConfirm()

    this.$mdDialog
      .show(
        this.$mdDialog.tmrPhaseToPhase({
          targetEvent,
          locals: { lots: this.lotsRead },
        })
      )
      .then(res => {
        if (res === 'updateProgressDone') {
          this.phaseToPhaseSuccess()
          this.isWarningShowed = false
        }
      })
      .finally(() => (this.confirming = false))
  }

  /**
   * MovementInbound.inbound success callback.
   */
  phaseToPhaseSuccess() {
    this.TmrToast.success('OPERATIONS.PHASETOPHASE.SUCCESS')
    this.onClear()
  }
}
